/* eslint-disable import/prefer-default-export */
/* eslint-disable @tanstack/query/no-deprecated-options */
import { makeStyles } from "@material-ui/styles";

const DSM_DARK_GREY = "#808080";

export const notificationPopoverStyles = makeStyles(() => ({
  root: {
    width: 360,
    display: "flex",
    flexDirection: "column",
  },
  header: {
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 28,
    paddingBottom: 28,
    borderRadius: 0,
    backgroundColor: "#49AB6C",
  },
  notificationsContainer: {
    height: 360,
    overflowY: "auto",
  },
  notificationItem: {
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 18,
    paddingBottom: 18,
    cursor: "pointer",
    borderBottomStyle: "solid",
    borderBottomColor: "#d9d9d9",
    borderBottomWidth: "1px",
    "&:hover": {
      backgroundColor: "#e8e8e8",
    },
  },
  notificationPreview: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    lineHeight: "1.5em",
    color: "#666",
  },
  noNotifications: {
    height: 360,
    padding: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const notificationModalStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    width: 800,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white",
    borderRadius: 8,
  },
  header: {
    paddingLeft: 40,
    paddingRight: 40,
    paddingTop: 24,
    paddingBottom: 24,
    backgroundColor: "#49AB6C",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  notificationsContainer: {
    maxHeight: 600,
    overflowY: "auto",
    paddingLeft: 40,
    paddingRight: 40,
    paddingTop: 32,
    paddingBottom: 32,
    "&>*:not(:last-child)": {
      borderBottomStyle: "solid",
      borderBottomColor: "#d9d9d9",
      borderBottomWidth: "1px",
      marginBottom: 12,
    },
  },
  buttonContainer: {
    paddingLeft: 40,
    paddingRight: 40,
    display: "flex",
    justifyContent: "flex-end",
    paddingBottom: 32,
  },
  modalBody: { width: "100%" },
  attachmentList: { padding: 0 },
  attachmentItem: { margin: "0.5em", listStyle: "none" },
}));

export const notificationAdminPageStyles = makeStyles({
  root: {
    width: "100%",
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 24,
    paddingBottom: 24,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 12,
  },
});

export const notificationFormStyles = makeStyles({
  actionsRow: {
    marginTop: 12,
    display: "flex",
    justifyContent: "flex-end",
  },
  saveButton: {
    marginRight: 8,
  },
  saveError: {
    marginTop: 8,
  },
});

export const notificationFormFieldsStyles = makeStyles({
  titleField: {
    marginBottom: 12,
  },
  groupsControl: {
    marginTop: 12,
  },
  selectAllMenuItem: {
    marginBottom: 12,
    borderBottom: "1px solid gray",
  },
});

export const notificationTableStyles = makeStyles({
  clickableRow: {
    cursor: "pointer",
  },
  errorText: {
    padding: "12px 16px",
  },
});

export const notificationAttachmentsStyles = makeStyles({
  uploadContainer: {
    marginTop: 12,
    marginRight: 8,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    "&>*:not(:last-child)": { marginRight: 8 },
    "&>*": { marginBottom: 8 },
  },
  fileList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "contents",
  },
  fileItem: {
    margin: "0.5em",
    display: "inline-block",
  },
  progressBar: {
    margin: "10px 5px",
  },
  uploadErrorsContainer: {
    marginTop: 8,
  },
});

export const prodProcessDatasetsPageStyles = makeStyles(() => ({
  sectionGrid: {
    width: "100%",
    padding: "16px",
    marginTop: "24px",
    border: "1px solid var(--dsm-color-neutral)",
    borderBottom: "0px",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  baselineGridTemplate: {
    grid: "auto/10fr 3fr",
  },
  baselineGridTemplateWithActive: {
    grid: "auto/10fr 2fr 3fr",
  },
  interventionsGridTemplate: {
    grid: "auto/1fr auto",
  },
  archiveGridTemplate: {
    grid: "auto/1fr",
  },
  bodyTextNeutralDarker: {
    color: "var(--dsm-color-neutral-darker)",
  },
  bodyTextNeutralDarkerWithMargin: {
    marginTop: "10px",
    color: "var(--dsm-color-neutral-darker)",
  },
  hintText: {
    color: DSM_DARK_GREY,
    fontSize: "10px",
    textAlign: "center",
    lineHeight: "16px",
  },
  editBaselineButton: {
    alignSelf: "center",
    marginBottom: "8px",
    whiteSpace: "nowrap",
  },
  addBaselineButton: {
    alignSelf: "center",
    marginBottom: "8px",
    display: "grid",
  },
  addInterventionButton: {
    alignSelf: "end",
  },
  sectionEmptyState: {
    paddingTop: "var(--dsm-spacing-px-16)",
    paddingBottom: "var(--dsm-spacing-px-16)",
    border: "1px solid var(--dsm-color-neutral)",
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",
  },
  roiConfirmButtonsBox: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "var(--dsm-spacing-px-6)",
    gap: "8px",
  },
  roiConfirmCancelButton: {
    width: "170px",
    height: "40px",
    borderRadius: "4px",
    textTransform: "none",
    fontSize: "15px",
    fontWeight: 700,
    backgroundColor: "#FFFFFF",
    border: "1px solid #0070BA",
    color: "#0070BA",
  },
  roiConfirmContinueButton: {
    width: "170px",
    height: "40px",
    borderRadius: "4px",
    textTransform: "none",
    fontSize: "15px",
    fontWeight: 700,
    backgroundColor: "#0070BA",
    border: "1px solid #0070BA",
    color: "#FFFFFF",
  },
  alignSelfStart: {
    alignSelf: "start",
  },
  datasetsTableIntroTitle: {
    color: "var(--dsm-color-basic-black) !important",
    fontWeight: 500,
    fontSize: "18px !important",
    lineHeight: "40px !important",
  },
}));

export const roiCalculatorStyles = makeStyles(() => ({
  pageContainer: {
    display: "flex",
    flexDirection: "column" as const,
    padding: "0px 0px 96px",
    gap: "32px",
    width: "100%",
    background: "#FFFFFF",
  },
  sectionColumn: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "16px",
  },
  sectionHeader: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "4px",
  },
  sectionTitle: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "24px",
    color: "#1B1B1B",
  },
  sectionDescription: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#1B1B1B",
  },
  pageHeaderRow: {
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  pageHeaderColumn: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "12px",
  },
  buttonsRow: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "12px",
  },
  baselineInterventionName: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "24px",
    color: "#003478",
  },
  pageTitle: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "34px",
    lineHeight: "40px",
    letterSpacing: "-0.02em",
    color: "#003478",
    marginTop: "12px",
  },
  viewMethodsLink: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "underline",
    color: "#0070BA",
  },
  methodsModalSectionTitle: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#1B1B1B",
    marginBottom: "12px",
  },
  methodsModalKpiColumn: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0",
  },
  methodsModalColumns: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0",
  },
  splitColumnsContainer: {
    display: "flex",
    alignItems: "stretch",
    gap: "24px",
  },
  splitColumn: {
    flex: 1,
  },

  lockedInput: {
    backgroundColor: "#F0F0F0 !important",
    borderRadius: "2px",
    boxShadow: "0 -5px 0 0 #F0F0F0",
    "& fieldset": {
      borderColor: "#808080 !important",
    },
    "&.Mui-disabled fieldset": {
      borderColor: "#808080 !important",
    },
  },
  currencySelectBox: {
    width: "592px",
  },
  inputFieldBox: {
    maxWidth: "583px",
  },
  stageSubtitle: {
    fontWeight: 500,
    fontSize: "16px",
    marginBottom: "16px",
    color: "#1B1B1B",
  },
  divider: {
    background: "#E0E0E0",
  },
  tabsWrapper: {
    paddingTop: 0,
  },
  tabs: {
    borderBottom: "1px solid #F0F0F0",
    minHeight: "36px",
    gap: "16px",
    "& .MuiTabs-indicator": {
      backgroundColor: "#005A95",
      height: "2px",
    },
  },
  stageTab: {
    minWidth: "auto",
    padding: "1px 4px 11px",
    marginRight: "16px",
    minHeight: "36px",
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "none" as const,
    color: "#808080",
    "&$stageTabError": {
      color: "var(--dsm-color-error)",
    },
    "&.Mui-selected": {
      color: "#005A95",
    },
  },
  stageTabError: {},
}));

export const roiResultsStyles = makeStyles(() => ({
  chartsRow: {
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "center",

    gap: "56px",
    width: "100%",
  },

  chartCard: {
    display: "flex",
    flexDirection: "column" as const,
    flexShrink: 0,
    width: "279px",
    minHeight: "425px",
  },
  chartTitle: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "24px",
    color: "#1B1B1B",
  },
  chartDescription: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontStyle: "italic" as const,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0",
    color: "#808080",
    marginBottom: "16px",
  },
  chartTitleRow: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "8px",

    marginBottom: "8px",
  },
  chartsRowDivider: {
    backgroundColor: "#E0E0E0",
  },

  barsRow: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "flex-end",
    gap: "55px",

    maxHeight: "270px",
    flexShrink: 0,

    marginTop: "auto",
  },

  barColumn: {
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "flex-end",
    alignItems: "stretch",
    flexShrink: 0,
    width: "112px",
    paddingTop: "32px",
    boxSizing: "border-box" as const,
  },

  barLabel: {
    position: "absolute" as const,
    bottom: "100%",
    left: 0,
    right: 0,
    height: "32px",
    boxSizing: "border-box" as const,
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0",
    textAlign: "center" as const,
    padding: "4px 8px",
  },
  barLabelBaseline: {
    backgroundColor: "#F0F7FB",
    color: "#0070BA",
  },
  barLabelIntervention: {
    backgroundColor: "#ECF7EB",
    color: "#007E4B",
  },

  bar: {
    position: "relative" as const,
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center",
    width: "100%",
    flexShrink: 0,
  },
  barBaseline: {
    backgroundColor: "#0070BA",
  },
  barIntervention: {
    backgroundColor: "#007E4B",
  },
  barValue: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "0",
    color: "#FFFFFF",
    textAlign: "center" as const,
    padding: "0 8px",

    overflowWrap: "anywhere" as const,
  },

  barValueUnit: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0",
    color: "#FFFFFF",
    textAlign: "center" as const,
    padding: "0 8px",

    overflowWrap: "anywhere" as const,
  },

  barValueOutside: {
    color: "#1B1B1B",
    padding: "0 8px 4px",
    marginBottom: "32px",
  },
  barsFooterDivider: {
    backgroundColor: "#E0E0E0",
    marginTop: "16px",
    marginBottom: "16px",
  },

  percentageBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 12px",
    borderRadius: "16px",
    border: "1px solid",
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  percentageBadgeDecrease: {
    borderColor: "#45AC34",
    color: "#45AC34",
    backgroundColor: "#ECF7EB",
  },
  percentageBadgeIncrease: {
    borderColor: "#E51F22",
    color: "#E51F22",
    backgroundColor: "#FCE9E9",
  },
  percentageRow: {
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "space-between",
    alignItems: "center",
  },
  percentageLabel: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0",
    color: "#6B6B6B",
  },

  metricCard: {
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    maxWidth: "1216px",
    height: "82px",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #E0E0E0",
    backgroundColor: "#F9FAFB",
  },
  metricLeft: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "12px",
  },
  metricTitle: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0",
    color: "#003478",
  },
  metricLabel: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0",
    color: "#003478",
  },
  metricDivider: {
    width: "1px",
    height: "24px",
    backgroundColor: "#003478",
  },
  metricRight: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "12px",
  },
  metricValue: {
    fontFamily: "Fira Sans",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0",
    color: "#003478",
  },
  metricNotAvailable: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#6B6B6B",
    fontStyle: "italic" as const,
  },
  metricHelpIcon: {
    width: "16px",
    height: "16px",
    color: "#6B6B6B",
    cursor: "pointer" as const,
  },
  percentageIcon: {
    width: "14px",
    height: "14px",
  },
  metricsColumn: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    gap: "32px",
    width: "100%",
  },
  noDataContainer: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    padding: "48px",
  },
  noDataMessage: {
    fontFamily: "Fira Sans",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#6B6B6B",
    textAlign: "center" as const,
  },
}));

export const homeButtonStyles = makeStyles({
  buttonBackground: {
    backgroundImage: ({ backgroundImage }: { backgroundImage: string }) =>
      backgroundImage,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter, Fira Sans",
    minHeight: "240px",
    paddingLeft: "32px",
    paddingTop: "32px",
    position: "relative",
  },
  buttonIcon: {
    bottom: "-9.29px",
    height: "138.29px",
    opacity: 0.4,
    position: "absolute",
    right: "-10.28px",
    width: "137.25px",
  },
  buttonIntro: {
    color: "white",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "24px",
    paddingRight: "80px",
  },
  buttonTitle: {
    color: "white",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    paddingBottom: "8px",
  },
});
